import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {PrismicRichText} from '@prismicio/react'
import type {FC} from 'react'
import {Container} from 'src/common/Container'
import {ListItem} from './components/ListItem'

/**
 * Props for `LinksList`.
 */
export type LinksListProps = SliceComponentProps<Content.LinksListSlice> & {context: {pageUid: string}}

/**
 * Component for "LinksList" Slices.
 */
const LinksList: FC<LinksListProps> = ({slice, context, index: componentIndex}) => (
  <Container data-slice-type={slice.slice_type} data-slice-variation={slice.variation} className="!pb-20 !pt-12">
    <div className="flex w-full max-w-[1200px] flex-col gap-12 px-5 md:px-10 lg:px-5 xl:px-0" data-aos="fade-up">
      <div className="flex flex-col gap-4 lg:gap-6">
        <span className="text-button-s text-ui-blue-450">{slice.primary.tag}</span>
        <PrismicRichText
          field={slice.primary.title}
          components={{
            heading2: ({children}) => (
              <h3 className="lg:text-tg-h2 text-32 leading-[normal] tracking-[-.32px] text-moss-black">{children}</h3>
            ),
            strong: ({children}) => <span className="text-moss-grey-400">{children}</span>,
          }}
        />
      </div>
      <div className="flex w-full flex-col divide-y-[1px] divide-moss-grey-150 border-y border-moss-grey-150">
        {slice.primary.list_items.map((item, index) => (
          <ListItem
            key={`link-item-${index}`}
            item={item}
            pageUid={context.pageUid}
            componentIndex={componentIndex}
            index={index}
          />
        ))}
      </div>
    </div>
  </Container>
)

export default LinksList
